import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { LLTTFInvitationView, LLTTFInvitationViewDefaultValues } from 'src/app/components/invitations/llttf-invitations/llttf-invitations';
import { AuthService } from 'src/app/services/auth.service';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';
import { ModalService } from 'src/app/services/modal.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-view-llttf-invitations',
    templateUrl: './view-llttf-invitations.component.html',
    styleUrls: ['./view-llttf-invitations.component.scss'],
    standalone: false
})
export class ViewLlttfInvitationsComponent {

  llttfInvitation:LLTTFInvitationView=LLTTFInvitationViewDefaultValues();
  id: string = '';
  auditLogs :any[]=[]
  modalSub!: Subscription;

  modalOpen = this._modalservice.getModalState();
  modalContent = '';
  modalTitle = '';
  modalOkButtonValue = 'OK';
  modalCancelButtonValue = 'CANCEL';
  modalOkButtonText = 'Ok';
  modalCancelButtonText = 'Cancel';
  pageName = CheckPageAccess.LLTTFINVITATIONS
  showEditButton = true;
  constructor(private _llttfinviteservice:LlttfInvitationService,private route:ActivatedRoute,private router:Router,private _modalservice:ModalService,
    private _toastservice:ToastService,private _authservice:AuthService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params)=>{
      this.id=params['id'];
      this._llttfinviteservice.getLLTTFInvitationDetailsForView(this.id).subscribe({
        next:(response)=>
          {
            this.llttfInvitation=response;
          }
      })

      this._llttfinviteservice.getLLTTFInvitationAuditLogs(this.id).subscribe({
        next:(response)=>
        {
          this.auditLogs=response;
        }
      })
     })
     this.showEditButton = this._authservice.getAccessControl().editLLTTFInvitation

     this.afterConfirmModalOps();
  }

  navigate() {
    this.router.navigateByUrl('/edit-llttf-invitation/'+this.id);
    }

    async copyToClipboard(text: string) {
      try {
        const clipboard = navigator.clipboard;
        await clipboard.writeText(text);
      } catch (error) {
        console.error('Error copying text to clipboard:', error);
      }
    }

    isUrl(): boolean {
      try {
        new URL(this.llttfInvitation.inviteLink);
        return true;
      } catch (e) {
        return false;
      }
    }

    askConfirmation(
      okButtonText: string,
      okButtonValue: string,
      cancelButtonText: string,
      cancelButtonValue: string,
      content: string,
      title: string
    ) {
      this.modalContent = content;
      this.modalTitle = title;
      this.modalOkButtonValue = okButtonValue;
      this.modalCancelButtonValue = cancelButtonValue;
      this.modalOkButtonText = okButtonText;
      this.modalCancelButtonText = cancelButtonText;

      this._modalservice.openModal();
    }

    afterConfirmModalOps() {
      this.modalSub = this._modalservice
        .getButtonClicked()
        .subscribe((button) => {
          switch (button) {
            case 'YES':
              this._llttfinviteservice.deleteLLTTFInvitation(this.id).subscribe({
                next: (response: any) => {
                  this._toastservice.showMessage("Invitation Deleted Successfully");
                  this.router.navigate(['/llttf-invite-list']);
                }
              })
            break;
            default:
              this._modalservice.closeModal();
          }
        });
    }

    ngOnDestroy(): void {
      if (this.modalSub) {
        this.modalSub.unsubscribe();
      }
    }

    deleteInvite()
    {
      this.askConfirmation("Yes, Delete",'YES','No, Cancel','NO','Are you sure you want to delete this invitation?','Delete Invitation');
    }
}
